import type { DayForecast } from "@/types";
import { Temporal } from '@js-temporal/polyfill'

/** Compute effective sun hours for a forecast day, intersected with the pot's sun window. */
export function computeSunHoursForDay(
  day: DayForecast,
  sunStart: string,
  sunEnd: string,
): number {
  let sunSecondsCount = 0
  if (day && sunStart && sunEnd) {
    const sunStartTime = Temporal.PlainTime.from(sunStart);
    const sunEndTime = Temporal.PlainTime.from(sunEnd);
    for (const hour of day.hours) {
      [hour.sunshine.q1, hour.sunshine.q2, hour.sunshine.q3, hour.sunshine.q4].forEach((sunshineInSeconds, index) => {
        const quarterTime = Temporal.PlainTime.from(hour.iso).add({ minutes: 15 * (index + 1) });
        if (Temporal.PlainTime.compare(quarterTime, sunStartTime) >= 0
          && Temporal.PlainTime.compare(quarterTime.add({ minutes: 15 }), sunEndTime) <= 0) {
          sunSecondsCount += sunshineInSeconds
        }
      });
    }
  }
  return sunSecondsCount / 60 / 60;
}

export function formatSunHours(hours: number): string {
  const totalMinutes = Math.round(hours * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${h}h${m.toString().padStart(2, "0")}`;
}